<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/xianglogosmall.png" alt="logo图">
      <p>&nbsp;&nbsp;</p>
    </div>
    <div
      class="text-h4 font-weight-regular text-center mb-2 px-4"
      width="100%"
    >
      上海新语信息技术有限公司 版权所有 Copyright©2022
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="color: white"
      >沪ICP备13004832号-1</a>
      <a
        target="_blank"
        style="color: white"
        @click="forgetpasswordClicked"
      >隐私政策</a>
    </div>
    <div>
      <p>&nbsp;&nbsp;</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    forgetpasswordClicked: function () {
      this.$router.push({path: '/policy'})
    },
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue